import { CircularProgress } from '@mui/material';

import { LoaderStyled } from './styled';
import { LoaderType } from './types';

export const Loader: LoaderType = (props) => (
  <LoaderStyled>
    <CircularProgress color="primary" {...props} />
  </LoaderStyled>
);
